import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    base: 'mono rounded-full px-4 py-3 text-sm lh-1 ring ring-inset i-flex duration peer-focus-visible:outline-auto',
    selected: 'ring-transparent bg-brand-1 c-grey-10'
  }
} satisfies VfConfig['toggleToken']
